export default __webpack_public_path__ + "static/media/bernay9.8cac74a3.jpg";